import axios from 'axios'

export function getBannerList(code) {
  const params = {
    code,
    game_code: 'FBPSD',
    per_page: 20,
    page: 1
  }
  return axios.get(
    'https://wx-api.shengtiangames.com/api/wx/home/cms_all/v2/page',
    { params }
  )
}

export function getHomeConfig(code) {
  const params = {
    code,
    game_code: 'FBPSD'
  }
  return axios.get(
    'https://wx-api.shengtiangames.com/api/wx/home/cms_all/v2/page',
    { params }
  )
}

export function getContentConfig(code) {
  const params = {
    code,
    game_code: 'FBPSD'
  }
  return axios.get(
    'https://wx-api.shengtiangames.com/api/wx/home/cms_all/v2/page',
    { params }
  )
}

export function loadNewsList({ lang, category, perPage = 10, page = 1 }) {
  const prefix = `fbpsd_${lang}`
  const catCodes = {
    latest: '',
    news: `${prefix}_news_xw`,
    notice: `${prefix}_news_gg`,
    event: `${prefix}_news_hd`
  }

  return axios.get(
    'https://xzy.shengtiangames.com/mini-game/xzy/battle-record/cms/news',
    {
      params: {
        game_code: 'FBPSD',
        type_code_prefix: prefix,
        type_code: catCodes[category] || '',
        per_page: perPage,
        page
      }
    }
  )
}

export function loadNewsDetail(id) {
  return axios.get(
    `https://xzy.shengtiangames.com/mini-game/xzy/battle-record/cms/news/${encodeURIComponent(
      id
    )}`,
    {
      params: {
        game_code: 'FBPSD'
      }
    }
  )
}
